import * as CONST from "./actionTypes";

const INIT_STATE = {
  error: "",
  loading: false,
  cryptoList: [],
  total: 0,
  AUDLoading: false
};
 /**
      * Used for handle response of crypto listing api
      */


const Crypto = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CONST.GET_CRYPTO:
      return {
        ...state,
        loading: true,
      };

    case CONST.GET_CRYPTO_SUCCESS:
      return {
        ...state,
        cryptoList: action.payload.data || [],
        total: action.payload.totalCount || 0,
        loading: false,
        error: "",
      };

    case CONST.GET_CRYPTO_FAIL:
      return {
        ...state,
        cryptoList: [],
        loading: false,
        error: "",
      };
  
    
    default:
      return state;
  }
};

export default Crypto;
